import { render, staticRenderFns } from "./MaterialBox.vue?vue&type=template&id=599ddaad"
import script from "./MaterialBox.vue?vue&type=script&lang=js"
export * from "./MaterialBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports